import React, { useState, useEffect, FC } from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import styled from "@emotion/styled";
import {TransitionProps} from "@mui/material/transitions";

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="left" ref={ref} {...props} />;
});

const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiBackdrop-root': {
        backgroundColor: 'rgba(0, 0, 0, 0.01)',
        backdropFilter: 'blur(2px)',
    },
    '& .MuiDialog-container': {
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        backgroundColor: 'rgba(0, 0, 0, 0.01)',
        '& .MuiPaper-root': {
            margin: '60px 0 0 auto',
            backgroundColor: '#fbcacd',
            color: 'black',
            borderLeft: '8px solid #f44336',
            borderRadius: '8px 0px 0px 8px;',
        },
    },
}));

const StyledDialogTitle = styled('div')({
    backgroundColor: '#fbcacd',
    color: 'black',
    padding: '24px 40px 10px 40px',
    fontSize: '18px',
    fontWeight: 800,
});

const StyledDialogContent = styled('div')({
    fontSize: '16px',
    fontWeight: 600,
    padding: '0 40px 24px 40px',
    backgroundColor: '#fbcacd',
});

interface UseErrorModalReturn {
    showErrorModal: (title: string, message: string) => void;
    ErrorModal: FC;
}

const useErrorModal = (): UseErrorModalReturn => {
    const [open, setOpen] = useState<boolean>(false);
    const [errorTitle, setErrorTitle] = useState<string>('');
    const [errorMessage, setErrorMessage] = useState<string>('');

    useEffect(() => {
        let timer: NodeJS.Timeout;
        if (open) {
            timer = setTimeout(() => {
                setOpen(false);
            }, 4000);
        }
        return () => clearTimeout(timer);
    }, [open]);

    const showErrorModal = (title: string, message: string): void => {
        setErrorTitle(title);
        setErrorMessage(message);
        setOpen(true);
    };

    const ErrorModal: FC = () => (
        <StyledDialog
            TransitionComponent={Transition}
            keepMounted
            open={open}
        >
            <StyledDialogTitle>{errorTitle}</StyledDialogTitle>
            <StyledDialogContent>
                    {errorMessage}
            </StyledDialogContent>
        </StyledDialog>
    );

    return { showErrorModal, ErrorModal };
};

export default useErrorModal;
